import {
  AICreateThreadOutput,
  BinderPolicyComparisonInput,
  CreateBorPolicy,
  ExtractQuoteData,
  MissingExtractionsOutput,
  OffsetLimitPagination,
  Quote,
  QuoteBinderComparisonInput,
  QuoteComparisonInput,
  QuoteInsightsInput,
  QuotePolicyComparisonInput,
} from 'types';
import { HttpMethods } from 'utils/http';
import { CapitolaClient } from './base';

export type QuoteQuery = OffsetLimitPagination;
export class QuoteClient extends CapitolaClient<Quote> {
  public get resourceName(): string {
    return 'quote';
  }

  public async createBorPolicy(props: CreateBorPolicy): Promise<void | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'bor-policy',
      body: { ...props },
    });
  }

  public async compareQuotes({
    quoteIds,
    expiringPolicyFileId,
    submissionId,
  }: QuoteComparisonInput): Promise<AICreateThreadOutput | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'compare',
      body: {
        quoteIds,
        expiringPolicyFileId,
        submissionId,
      },
    });
  }

  public async missingExtractions({
    quoteIds,
    expiringPolicyFileId,
    submissionId,
  }: QuoteComparisonInput): Promise<MissingExtractionsOutput | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'missing-extractions',
      body: {
        quoteIds,
        expiringPolicyFileId,
        submissionId,
      },
      fetchOptions: { throwOnError: true },
    });
  }

  public async extractQuoteData({ submissionId, fileId, extractionType }: ExtractQuoteData): Promise<void | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'extract',
      body: {
        submissionId,
        fileId,
        extractionType,
      },
    });
  }

  public async compareQuoteBinder({
    quoteId,
    binderIds,
  }: QuoteBinderComparisonInput): Promise<AICreateThreadOutput | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'compare-quote-binder',
      body: {
        quoteId,
        binderIds,
      },
    });
  }

  public async compareBinderPolicy({
    quoteId,
    policyIds,
  }: BinderPolicyComparisonInput): Promise<AICreateThreadOutput | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'compare-binder-policy',
      body: {
        quoteId,
        policyIds,
      },
    });
  }

  public async compareQuotePolicy({
    quoteId,
    policyIds,
  }: QuotePolicyComparisonInput): Promise<AICreateThreadOutput | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'compare-quote-policy',
      body: {
        quoteId,
        policyIds,
      },
    });
  }

  public async getInsights({ fileIds, submissionId }: QuoteInsightsInput): Promise<AICreateThreadOutput | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'insights',
      body: {
        fileIds,
        submissionId,
      },
    });
  }
}
